import { connect } from "react-redux";
import { ClienteViewProps, mapDispatchToClienteProps, mapStateToClienteProps } from "../cliente.controll";
import { Cliente } from "../cliente.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef,GridValueGetter } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { ClienteCadastro } from "./cliente.cad";
import { Endereco } from "../../../data.types";

const getEnderecoCliente = (prm:Endereco[]) =>{ 
    let endereco = ""
    prm.map(value=>{
        if(endereco !== "")
            endereco = endereco +" | " + value.rua +" N° "+value.numero
        else endereco = value.rua +" N° "+value.numero;

    })
    return endereco;
}

export const columnsCliente: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 3 },
    { field: 'sobrenome', headerName: 'Sobrenome', flex: 1 },
    { field: 'whatsapp', headerName: 'WhatsApp', flex: 3 },
    { field: 'enderecos', headerName: 'Endereço', flex: 3,valueGetter:getEnderecoCliente },
    { field: 'revenda', headerName: 'Revendedor?', flex: 2, renderCell:(prm)=>prm.value?"Sim":"Não" },
]

function ClienteList(props: ClienteViewProps) {
    const { clienteActions, clienteState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = clienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = clienteActions

    useEffect(()=>{
        read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return ClienteCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Clientes Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                multFieldSearch
                fieldSearch={["nome","whatsapp"]}
                placeholderTextSearch="Buscar nome ou whatsapp"
                columns={columnsCliente}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: ()=>read()
                }}
                ListItemTextPrimary={(row: Cliente) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                ListItemTextSecondary={(row: Cliente) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                        {row.enderecos.length > 0 && (
                            <Typography component={"span"}>{row.enderecos[row.idx_endereco_main].rua}</Typography>
                        )}

                    </Box>
                }
                
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToClienteProps,mapDispatchToClienteProps)(ClienteList);
